import { render, staticRenderFns } from "./PaidStores.vue?vue&type=template&id=aaaee8f0"
import script from "./PaidStores.vue?vue&type=script&lang=ts"
export * from "./PaidStores.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports